import * as React from 'react'
import { PageProps } from '@logic'
import { TransferEquaCashShared } from '@modules/referrals/components/equa-transfer-component'

type Props = PageProps

export const GuestTransferEquaCash = (props: Props) => {
    return <TransferEquaCashShared {...props} forGuest={true} />
}
